@if (editable) {
  <div class="max-w-6xl mx-auto">

    <!-- Header -->
    <div class="flex items-center justify-between mb-6">

      <div class="flex items-center gap-3">

        <h2 class="text-2xl font-semibold text-[#1E2A78]">
          {{ 'CREDIT_SECTION_HIGHLIGHTS.TITLE' | translate }}
        </h2>

        <span
          class="px-3 py-1 text-sm font-medium bg-indigo-100 text-[#1E2A78] rounded-full">

          {{ items.length }}

        </span>

      </div>

      <button
        type="button"
        (click)="addItem()"
        [disabled]="!canAddItem"
        [title]="canAddItem ? '' : ('CREDIT_SECTION_HIGHLIGHTS.ALL_TITLES_USED' | translate)"
        class="section-add-btn">

        <span class="text-lg">+</span>
        {{ 'CREDIT_SECTION_HIGHLIGHTS.ADD_HIGHLIGHT' | translate }}

      </button>

    </div>

    <!-- Empty State -->
    @if (items.length === 0) {
      <div class="bg-gradient-to-r from-indigo-50 to-blue-50 border border-indigo-100 rounded-2xl p-10 text-center">

        <div class="text-5xl mb-3">📋</div>

        <h3 class="text-lg font-semibold text-[#1E2A78]">
          {{ 'CREDIT_SECTION_HIGHLIGHTS.NO_HIGHLIGHTS' | translate }}
        </h3>

        <p class="text-gray-500 mt-2">
          {{ 'CREDIT_SECTION_HIGHLIGHTS.EMPTY_HINT' | translate }}
        </p>

      </div>
    }

    <!-- Highlight List -->
    <div class="space-y-4" cdkDropList (cdkDropListDropped)="onItemDrop($event)">

      @for (entry of displayItems; track entry.item) {
        <div cdkDrag cdkDragLockAxis="y" class="section-drag-item bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">

          <!-- Accordion Header -->
          <div
            (click)="entry.item.expanded = !entry.item.expanded"
            class="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50 transition">

            <div class="flex min-w-0 items-center gap-4">

              <app-section-drag-handle cdkDragHandle (click)="$event.stopPropagation()"></app-section-drag-handle>

              <div
                class="w-10 h-10 rounded-xl bg-indigo-100 text-[#1E2A78] font-semibold flex items-center justify-center">

                {{ entry.number }}

              </div>

              <div class="min-w-0">

                <h3 class="font-semibold text-gray-800 wrap-anywhere">

                  {{ entry.item.title || ('CREDIT_SECTION_HIGHLIGHTS.UNTITLED' | translate) }}

                </h3>

              </div>

            </div>

            <div class="flex items-center gap-2">

              <button
                (click)="requestRemoveItem(entry.index); $event.stopPropagation()"
                class="section-delete-btn">

                {{ 'COMMON.DELETE' | translate }}

              </button>

              <div
                class="w-8 h-8 flex items-center justify-center text-gray-500">

                @if (!entry.item.expanded) {
                  <span>▼</span>
                } @else {
                  <span>▲</span>
                }

              </div>

            </div>

          </div>

          <!-- Accordion Body -->
          @if (entry.item.expanded) {
            <div class="border-t border-gray-100 p-5">

              <div class="grid lg:grid-cols-3 gap-5">

                <!-- Left Panel -->
                <div class="space-y-5">

                  <!-- Title -->
                  <div>

                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      {{ 'CREDIT_SECTION_HIGHLIGHTS.HIGHLIGHT_TITLE' | translate }}
                    </label>

                    <select
                      [(ngModel)]="entry.item.code"
                      (ngModelChange)="onHighlightChange(entry.item)"
                      class="w-full h-11 px-3 border rounded-xl"
                      [class.border-gray-300]="!isTitleDuplicate(entry.item)"
                      [class.border-red-400]="isTitleDuplicate(entry.item)">

                      <option [ngValue]="null">
                        {{ 'CREDIT_SECTION_HIGHLIGHTS.SELECT_TITLE' | translate }}
                      </option>

                      <!-- A title used by another highlight is not offered again. -->
                      @for (option of titleOptionsFor(entry.item); track option.value) {
                        <option [ngValue]="option.value">

                          {{ option.label | translate }}

                        </option>
                      }

                    </select>

                    @if (isTitleDuplicate(entry.item)) {
                      <p class="mt-2 text-xs text-red-600">
                        {{ 'CREDIT_SECTION_HIGHLIGHTS.DUPLICATE_TITLE' | translate }}
                      </p>
                    }

                  </div>

                </div>

                <!-- Right Panel -->
                <div class="lg:col-span-2 space-y-4">

                  <div>

                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      {{ 'CREDIT_SECTION.CONTENT' | translate }}
                    </label>

                    <app-rich-text-editor
                      [(ngModel)]="entry.item.content"
                      minHeight="140px"
                      [placeholder]="'CREDIT_SECTION.CONTENT' | translate"
                    ></app-rich-text-editor>

                  </div>

                </div>

              </div>

            </div>
          }

        </div>
      }

    </div>

    <app-popup
      [(show)]="showDeletePopup"
      title="CREDIT_SECTION_HIGHLIGHTS.DELETE_HIGHLIGHT"
      type="confirm"
      [message]="deleteMessage"
      confirmText="COMMON.DELETE"
      cancelText="COMMON.CANCEL"
      (confirmed)="confirmRemoveItem()"
    ></app-popup>

  </div>
} @else {

  <!-- PREVIEW MODE -->
  <div class="space-y-5">

    @for (item of items; track $index) {
      <div class="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">

        <h3 class="text-xl font-semibold text-[#1E2A78] mb-4 wrap-anywhere">
          {{ item.title }}
        </h3>

        <div class="rich-text-content wrap-anywhere text-gray-700" [innerHTML]="item.content | richText"></div>

      </div>
    }

  </div>

}